module.exports = __webpack_public_path__ + "5ad8888f13adbe6f653eda88a42c5f5e.svg";